import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type SetStateAction,
  type ReactNode,
} from 'react'

type LoginModalContextType = {
  isLoginOpen: boolean
  setIsLoginOpen: Dispatch<SetStateAction<boolean>>
  isRegisterOpen: boolean
  setIsRegisterOpen: Dispatch<SetStateAction<boolean>>
  isForgotOpen: boolean
  setIsForgotOpen: Dispatch<SetStateAction<boolean>>
  lastOpened: 'login' | 'register'
  setLastOpened: Dispatch<SetStateAction<'login' | 'register'>>
}

const LoginModalContext = createContext<LoginModalContextType | undefined>(undefined)

export const LoginModalProvider = ({ children }: { children: ReactNode }) => {
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [isRegisterOpen, setIsRegisterOpen] = useState(false)
  const [isForgotOpen, setIsForgotOpen] = useState(false)
  const [lastOpened, setLastOpened] = useState<'login' | 'register'>('login')

  return (
    <LoginModalContext.Provider
      value={{
        isLoginOpen,
        setIsLoginOpen,
        isRegisterOpen,
        setIsRegisterOpen,
        isForgotOpen,
        setIsForgotOpen,
        lastOpened,
        setLastOpened,
      }}>
      {children}
    </LoginModalContext.Provider>
  )
}

export const useLoginModal = (): LoginModalContextType => {
  const context = useContext(LoginModalContext)
  if (!context) {
    throw new Error('useLoginModal must be used within a LoginModalProvider')
  }
  return context
}
